export default __webpack_public_path__ + "static/media/ilgazzettino.27bf0bf5.png";